<template>
  <div>
    <vxe-grid v-bind="addTableList" ref='xGrid' @cell-dblclick="dbClick">
      <template v-slot:toolbar>
        <vxe-toolbar custom>
          <template v-slot:buttons>
            <vxe-form>
              <vxe-form-item>
                <template v-slot>
                  <vxe-input v-model="searchVal" @keyup.enter.native="searchClick"
                    :placeholder="$t('message.placeholder.search')">
                  </vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item>
                <template v-slot>
                  <!-- <vxe-button status="primary" icon="el-icon-search"   @click="searchClick">{{$t('message.button.search')}}</vxe-button> -->
                  <div>
                    <el-button type="primary" icon="el-icon-search" size="small"
                      @click="searchClick">{{ $t('message.button.search') }}
                    </el-button>

                    <el-button type="success" icon="el-icon-folder-checked" size="small" @click="addListClick">{{
                      $t("message.button.submit") }}
                    </el-button>
                  </div>
                </template>
              </vxe-form-item>
              <vxe-form-item>
                <slot></slot>
              </vxe-form-item>
            </vxe-form>
          </template>
        </vxe-toolbar>
      </template>
    </vxe-grid>
    <el-pagination small v-if="paginationShow" class="pagination" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next, jumper"
      :total="totalRecords">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "searchAdd", //模板名称
  data() {
    return {
      searchVal: "",
      get_change_info: "",
      rols_text: [],
      tableShow: false,
      oldTableValue: [],
      rols_text: [],
      cols: [],

      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,
      totalRecords: '',
      paginationShow: false,

      addTableList: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "530",
        size: "small",
        columns: [],
        data: [],
        treeConfig: {
          lazy: true,
          children: 'children',
          hasChild: 'hasChildren',
          loadMethod: this.loadChildrenMethod
        },
        editConfig: {
          trigger: 'dblclick',
          mode: 'row',
          showIcon: false,
          // activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: 'cell'
        },
      },
    }
  },
  mounted() { },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchClick()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchClick()
      // const { data: res } = await this.$http.get(loadTableUrl);
    },
    dbClick(row) {
      console.log(row.row);
      let arr = [row.row];
      this.$emit("listDbClick", arr);
    },
    addListClick() {
      //console.log(row);
      var addRow = this.$refs.xGrid.getCheckboxRecords();
      this.$emit('listDbClick', addRow);
    },
    async searchClick() {
      var obj_get = {
        //获取url参数
        baseClassId: 106,
        value: this.searchVal,
        size: this.pageSize,
        page: this.currentPage,
        searchType: 1
      };
      var vm = this;
      if (this.searchVala == '') {
        vm.$message({
          showClose: true,
          message: this.$t('message.warning.searchErr_01'),
          type: 'warning'
        });
      }
      const { data: res } = await this.$http.get(`/pmdm/search/simple${this.params(obj_get)}`);
      this.totalRecords = res.object.table.totalRecords
      if (this.totalRecords == 0) {
        this.$message({
          showClose: true,
          message: this.$t("message.warning.searchErr_02"),
          type: "warning",
        });
        this.addTableList.data = [];
        return
      }
      this.paginationShow = true;
      let items = res.object.table.columnInfo.names;
      // console.log(1111,items);
      this.addTableList.columns = items.map((item, index) => { return { field: index, title: item } });
      var checkbox_ = { type: 'checkbox', title: '', width: 40 };
      this.addTableList.columns.unshift(checkbox_);

      items = res.object.table.rows;
      let arr = [];
      for (var i = 0; i < items.length; i++) {
        var rols_ = {};
        rols_.authTag = items[i].authTag;
        //console.log(this.rols[i].cells);
        for (var j = 0; j < items[0].cells.length; j++) {
          if (items[i].cells[j] == null) {
            rols_[j] = "";
          } else {
            rols_[j] = items[i].cells[j].val;
            rols_['itemClass'] = items[i].objClass
            rols_['id'] = items[i].objId
            rols_['manufacturerId'] = items[i].manufacturerId
          }
        }
        arr.push(rols_);
      };
      this.addTableList.data = arr;
    }
  },
  created() { }
};
</script>

<style scoped>
.pagination {
  margin-top: 15px;
  text-align: left;
}
</style>